module.exports = __webpack_public_path__ + "static/media/satellite.3daa04b0.svg";